import { useShortUrl } from '@app/api';

export const useLinkToMeeting = (participationId: string) => {
  const shortUrl = useShortUrl();
  return `${shortUrl}/study/start/${participationId}`;
};
